module.exports = __webpack_public_path__ + "static/media/HCMM209.57870f43.jpg";